import React, { useEffect, useRef } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Checkbox, FormControlLabel, Grid, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DefaultUploadFile from "../../../components/default-upload-file";
import { useCadastrosBasicoDispatch, useCadastrosBasicoState } from "../context/cadastros-basico-context";
import { useCadastrosBasicoController } from "../context/cadastros-basico-controller";
import { ACTION_TYPES, FORM_TYPES } from "../context/cadastros-basico-reducer";
import PlainTextArea from "../../../components/plain-text-area";

export const NoticiasForm = () => {
    const { dataRequest, file, categoriesNews } = useCadastrosBasicoState();
    const cadastrosBasicoDispatch = useCadastrosBasicoDispatch();
    const { handleOnChangeForm, loadCategoriesNews } = useCadastrosBasicoController();
    const firstInputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
        (async () => {
            await loadCategoriesNews();
        })();
    }, []);
    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2}>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Titulo</InputLabel>
                        <OutlinedInput
                            ref={firstInputRef}
                            size="small"
                            inputProps={{ min: 0 }}
                            error={dataRequest?.title === undefined || dataRequest?.title.length === 0 ? true : false}
                            name="input-title"
                            value={dataRequest?.title}
                            defaultValue={dataRequest?.title}
                            onChange={(e) => handleOnChangeForm(FORM_TYPES.news, e)}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Subtitulo</InputLabel>
                        <OutlinedInput
                            size="small"


                            inputProps={{ min: 0 }}
                            name="input-subtitle"
                            value={dataRequest?.subtitle}
                            defaultValue={dataRequest?.subtitle}
                            onChange={(e) => handleOnChangeForm(FORM_TYPES.news, e)}
                            fullWidth
                        />
                    </Grid>

                    <Grid
                        item
                        lg={4}
                        sm={4}
                        xl={4}
                    >
                        <InputLabel>Data da Publicação</InputLabel>
                        <DesktopDatePicker minDate={dayjs()}

                            format='DD/MM/YYYY'
                            slotProps={{ textField: { fullWidth: true, size: "small", error: dataRequest?.publication === undefined || dataRequest?.publication.length === 0 ? true : false } }}

                            value={dataRequest?.publication != null ? dayjs(dataRequest?.publication) : null}
                            onChange={(value: Dayjs | null) => {
                                let publication = value?.format("YYYY-MM-DD");
                                cadastrosBasicoDispatch({
                                    type: ACTION_TYPES.setDataRequest,
                                    payload: { ...dataRequest, publication },
                                });
                            }}

                        />

                    </Grid>
                    <Grid item lg={6}
                        sm={6}
                        xl={6}>
                        <InputLabel>Categoria</InputLabel>
                        <Select
                            size="small"
                            name='select-category'
                            error={dataRequest?.categoryId === undefined || dataRequest?.categoryId === 0 ? true : false}

                            value={dataRequest?.categoryId}
                            defaultValue={dataRequest?.categoryId}
                            onChange={(e) => handleOnChangeForm(FORM_TYPES.news, e)}
                            fullWidth
                        >
                            <MenuItem value={undefined} key={0}>
                                <em>Selecionar</em>
                            </MenuItem>
                            {categoriesNews?.map((element) => {
                                return (
                                    <MenuItem value={element.id} key={element.id}>{element.name}</MenuItem>
                                );
                            })}

                        </Select>
                    </Grid>
                    <Grid
                        item
                        lg={2}
                        sm={2}
                        xl={2}
                        direction="column"
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                        <FormControlLabel name="chk-published" onChange={(e) => handleOnChangeForm(FORM_TYPES.news, e)} control={<Checkbox defaultChecked={dataRequest?.published} />} label="Publicado" />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Texto</InputLabel>
                        <PlainTextArea
                            size="small"


                            // inputProps={{ min: 0 }}
                            rows={15}
                   
                            name="input-text"
                            value={dataRequest?.text}
                            // defaultValue={dataRequest?.text}
                            onChange={(e) => handleOnChangeForm(FORM_TYPES.news, e)}
                            fullWidth
                        />
                    </Grid>
                    <Grid
                        item
                        lg={12}
                        sm={12}
                        xl={12}
                    >
                        <InputLabel>Imagem de Destaque</InputLabel>
                        <DefaultUploadFile
                            setFileUpload={(file) => {
                                cadastrosBasicoDispatch({
                                    type: ACTION_TYPES.setFile,
                                    payload: file
                                });
                            }}
                            file={file}
                            id="input"
                            extensions={["jpg", "jpeg", "png"]}
                            maxFileSizeMb={10}
                        />
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </React.Fragment>
    );
}